import { TableVisibilityCell } from '../../Table'

import {
  getButtonTooltipTextKey,
  getPayloadData,
} from './TaskTableRowVisibility.utils'

function TaskTableRowVisibility({ item, ...restProps }) {
  const { visible_to_tenant: isVisible } = item

  return (
    <TableVisibilityCell
      {...restProps}
      getButtonTooltip={getButtonTooltipTextKey}
      getPayloadData={getPayloadData}
      isVisible={isVisible}
    />
  )
}

export default TaskTableRowVisibility
